import { gql } from 'graphql-tag'

export const fetchAdminCampaigns = gql`
  query AdminCampaignPage($date: String!, $stationId: ID, $includeChainCampaigns: Boolean) {
    campaigns(stationId: $stationId, includeChainCampaigns: $includeChainCampaigns) {
      id
      name
      description
      startTime
      endTime
      stationId
    }
    campaignsAfterDate(date: $date, stationId: $stationId) {
      id
      name
      description
      startTime
      endTime
      stationId
    }
  }
`

export const addNewCampaignMutation = gql`
  mutation AddNewCampaign($input: CampaignInput!) {
    addCampaign(input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`
export const updateCampaignMutation = gql`
  mutation UpdateCampaign($id: ID!, $input: CampaignInput!) {
    updateCampaign(id: $id, input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`

export const addNewStationCampaignMutation = gql`
  mutation AddNewStationCampaign($stationId: ID!, $input: CampaignInput!) {
    addStationCampaign(stationId: $stationId, input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`

export const updateStationCampaignMutation = gql`
  mutation UpdateStationCampaign($id: ID!, $stationId: ID!, $input: CampaignInput!) {
    updateStationCampaign(id: $id, stationId: $stationId, input: $input) {
      id
      name
      description
      startTime
      endTime
    }
  }
`
